import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var normalizeRequestorTransformer = function normalizeRequestorTransformer(transformers) {
  if (!transformers) return [];
  if (Array.isArray(transformers)) return transformers;
  return [transformers];
};

var matchName = function matchName(transformerName) {
  return function (_ref) {
    var name = _ref.name;
    return name === transformerName;
  };
};

export var TransformerManager = /*#__PURE__*/function () {
  function TransformerManager(transformers) {
    var predefinedNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, TransformerManager);

    this.transformers = void 0;
    var transformersFunctions = normalizeRequestorTransformer(transformers);
    this.transformers = transformersFunctions.map(function (fn, index) {
      var _predefinedNames$inde;

      return {
        name: (_predefinedNames$inde = predefinedNames[index]) !== null && _predefinedNames$inde !== void 0 ? _predefinedNames$inde : "_transformer".concat(index),
        transformer: fn
      };
    });
  }

  _createClass(TransformerManager, [{
    key: "get",
    value: function get(transformerName) {
      var _ref2 = this.transformers.find(matchName(transformerName)) || {
        transformer: null
      },
          transformer = _ref2.transformer;

      return transformer;
    }
  }, {
    key: "insert",
    value: function insert(name, transformer, options) {
      var namedTransformer = {
        name: name,
        transformer: transformer
      };
      var hasValidOptions = options && (options.after || options.before);

      if (!hasValidOptions) {
        this.transformers.push(namedTransformer);
        return;
      }

      var cursorName = options.after || options.before;
      var index = this.transformers.findIndex(matchName(cursorName));

      if (index === -1) {
        throw new Error("Transformer named \"".concat(cursorName, "\" doesn't exist. Available names are \"").concat(this.names(), "\""));
      }

      var insertionIndex = options.after ? index + 1 : index;
      this.transformers.splice(insertionIndex, 0, namedTransformer);
    }
  }, {
    key: "values",
    value: function values() {
      return this.transformers.map(function (_ref3) {
        var transformer = _ref3.transformer;
        return transformer;
      });
    }
  }, {
    key: "names",
    value: function names() {
      return this.transformers.map(function (_ref4) {
        var name = _ref4.name;
        return name;
      });
    }
  }]);

  return TransformerManager;
}();